import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductBrandCarouselCollectionsSlider(slider) {
    const slick = initSlickWithArrowEvent(
        $(slider),
        {
            dots: false,
            dotsClass: 'slick-dots',
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        rows: 2,
                        slidesPerRow: 2
                    }
                }
            ]
        }
    );
}

function observeShopProductBrandCarouselCollectionsSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initShopProductBrandCarouselCollectionsSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-wrapper-shop-product-brand-carousel-collections .maier-carousel-list').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-wrapper-shop-product-brand-carousel-collections .maier-carousel-list').forEach(slider => initShopProductBrandCarouselCollectionsSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierCarouselCollections() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeShopProductBrandCarouselCollectionsSlider();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierCarouselCollections);
} else {
    setupMaierCarouselCollections();
}

